import { CloseOutlined, HolderOutlined, PictureOutlined } from '@ant-design/icons';
import { ProductDoc } from '@gooduncles/gu-app-schema';
import { Button, Tag } from 'antd';
import { CSSProperties, ReactNode, forwardRef } from 'react';
import { formatNumber } from 'src/utils/common';

import classes from './FavoriteProductRow.module.scss';

interface FavoriteProductRowProps {
  productId: string;
  product: ProductDoc | null;
  onRemove: () => void;
  isDragging?: boolean;
  dragHandle?: ReactNode;
  style?: CSSProperties;
}

const StatusBadges = ({ product }: { product: ProductDoc | null }) => {
  if (!product) {
    return <Tag color='red'>존재하지 않음</Tag>;
  }
  return (
    <>
      {product._timeDelete ? <Tag color='orange'>삭제됨</Tag> : null}
      {product.hidden ? <Tag>숨김</Tag> : null}
      {product.state === 'out-of-stock' ? <Tag color='gold'>품절</Tag> : null}
      {product.state === 'discontinued' ? <Tag color='red'>판매중지</Tag> : null}
    </>
  );
};

const FavoriteProductRow = forwardRef<HTMLDivElement, FavoriteProductRowProps>(
  ({ productId, product, onRemove, isDragging, dragHandle, style }, ref) => {
    const thumbnail = product?.thumbnail ?? product?.imageUrl;
    return (
      <div ref={ref} className={isDragging ? `${classes.row} ${classes.dragging}` : classes.row} style={style}>
        {dragHandle ?? (
          <div className={classes.dragHandle}>
            <HolderOutlined />
          </div>
        )}
        {thumbnail ? (
          <img src={thumbnail} alt={product?.fullName ?? productId} className={classes.thumbnail} />
        ) : (
          <div className={classes.thumbnailPlaceholder}>
            <PictureOutlined />
          </div>
        )}
        <div className={classes.info}>
          <div className={classes.nameLine}>
            <span className={classes.name}>{product?.fullName ?? productId}</span>
            <StatusBadges product={product} />
          </div>
          <div>
            <span className={classes.productId}>{productId}</span>
            {product ? <span className={classes.price}> · {formatNumber(product.price, 0)}원</span> : null}
          </div>
        </div>
        <div className={classes.actions}>
          <Button type='text' size='small' icon={<CloseOutlined />} onClick={onRemove} />
        </div>
      </div>
    );
  },
);

FavoriteProductRow.displayName = 'FavoriteProductRow';

export default FavoriteProductRow;
